export const environment = {
  namespace: 'unica-card',
  webToken: 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJNZXJhayIsInN1YiI6IndlYkBiYWh1Z3JvdXAuY29tIiwiaWF0IjoxNzM1NTg3MjU5LCJleHAiOjQ4ODkxODcyNTksImF1dGhvcml0aWVzIjpbIlFVRVJZX1BPU1RBTF9DT0RFX0NBVCIsIkFWQUlMQUJMRV9FTUFJTCIsIkNBTkNFTF9DSEFOR0VfUkVRVUVTVCIsIkVNQUlMX0NPTkZJUk1BVElPTiIsIkVYRUNVVEVfQ1VSUCIsIkdFVF9BQ0NFU1NfVE9LRU4iLCJQQVNTV09SRF9SRVNFVCIsIlBBU1NXT1JEX1JFQ09WRVJZIiwiQ0hBTkdFX1BBU1NXT1JEIiwiTElTVF9BR0VOVCIsIkVYRUNVVEVfS1lDIiwiT1RQX1ZBTElEQVRJT04iLCJBUFBMSUNBVElPTl9WSUVXRVJfV0VCIiwiT1RQX0FVVEhPUklUWSIsIlZBTElEQVRFX01PQklMRV9QSE9ORV9OVU1CRVIiLCJQSE9ORV9WQUxJREFUSU9OIiwiQ0FOQ0VMX0FQUExJQ0FUSU9OIiwiUVVFUllfQ09NTUVSQ0lBTF9BQ1RJVklUWV9DQVQiLCJRVUVSWV9KT0JTX0NBVCIsIkZJTkRfQllfVE9LRU4iLCJDUkVBVEVfQVBQTElDQVRJT05fV0VCIiwiUVVFUllfU0VDVVJJVFlfUVVFU1RJT05fQ0FUIl0sInJvbGVzIjpbIlJPTEVfV0VCIl0sIm5zIjoidW5pY2EtY2FyZCJ9.U28u5bWsVgcA_U_vwFZv58jCE_ORNslkGKUrzVb91BXYlkfv2eeMAy52qq9D09BscNmSEseV125pLXyWeYiPSA',
  serviceEndpoint: 'https://www.unicacard.com',
  homeEndpoint: 'https://www.unicacard.com',
  bahuProcessingHost: 'https://bahuprocessing.com',
  usaHost: 'www.unicacard.com',
  recaptchaKey: '6Ldaf7cqAAAAAF4De22rpbixFv19XVyLBs_8Y4AT',
  production: true,
  allowIndexing: true,
  cardPan: '5502 9600 XXXX XXXX',
  productName: 'UnicaCard',
  programName: 'UnicaCard',
  programNameHub: 'USA UnicaCard',
  programNameRemittance: 'Remesas UnicaCard',
  programHubName: 'USA UnicaCard',
  title: 'UnicaCard',
  androidStore: 'https://play.google.com/store/apps/details?id=mx.com.glider.spiral.mobile.unicacard',
  hubAndroidStore: 'https://play.google.com/store/apps/details?id=com.bahugroup.hub.unicacard',
  remittanceAndroidStore: 'https://play.google.com/store/apps/details?id=com.bahuprocessing.remittance.unicacard',
  iosStore: 'https://apps.apple.com/us/app/unicacard/id1580759407',
  hubIosStore: 'https://apps.apple.com/app/usa-unicacard/id6701984572',
  remittanceIosStore: 'https://apps.apple.com/app/remesas-unicacard/id6682151443',
  es: 'MEX',
  faqs_config1: true,
  faqs_guatemala: false,
  noSSNRequireDPI: false,
  home_carousel: true,

  mexAndroidStore: '',
  mexIosStore: '',
  hubName: '',
  hubInMobileApp: false,

  socialNetworks: {
    facebook: 'https://www.facebook.com/people/Cashingo/100089272132771/',
    instagram: 'https://www.instagram.com/cashingocash/',
    tiktok: 'https://www.tiktok.com/@cashingocash?lang=es',
    twitter: 'https://twitter.com/Wooraleecard',
    youtube: 'https://www.youtube.com/channel/UCadAUN9KwHjRsE7ivJncsHg',
    linkedin: 'https://www.linkedin.com/in/cashingo-undefined-289668262/'
  },
  contactUsTextColor: '#ffffff',
  cardTextStroked: false,
  borderCard: false,
  textWhiteCard: false,
  footer: {
    bgSecondaryColor: true,
    textPrimaryColor: false,
    termConAlignLeft: true,
    bgColor: '#272BD0',
    showSocialNetworks: false
  },
  main: {
    bgColor: '#ffffff',
    textColor: '',
    reloadCardBg: '',
    navbarWhiteIcon: false
  },

};
